import axios from 'axios';

class NotificationService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getAllCompanyPreferences(companyId) {
        return axios
            .get(this.state.apiUrl + 'admin/getAllCompanyPreferences?companyId=' + companyId, { silent: true })
            .then((res) => {
                return res.data.data;
            })
            .catch((err) => {
                return err;
            });
    }

    deleteCompanyPreferences(id) {
        return axios
            .delete(this.state.apiUrl + 'admin/deleteCompanyPreferences/' + id)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    saveCompanyPreferences(params) {
            return axios
                .post(this.state.apiUrl + 'admin/saveCompanyPreferences', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
}

export default NotificationService;
